
import React, { useState } from 'react';
import axios from 'axios';
import { Button, LinearProgress, Box, Typography, Alert, TextField } from '@mui/material';
import { styled } from "@mui/system";

const Input = styled('input')({
  display: 'none',
});

const Upload = () => {
  const [files, setFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [uploadErrors, setUploadErrors] = useState([]);
  const [token, setToken] = useState()
  const [successAlert, setSuccessAlert] = useState(false);

  const handleFilesChange = (event) => {
    setFiles(Array.from(event.target.files));
    setUploadErrors([]); // Reset errors on new file selection
    setSuccessAlert(false); // Hide success alert on new file selection

  };

  const handleUpload = async () => {
    setSuccessAlert(false); // Hide success alert on new file selection

    const uploaders = files.map((file) => {
      const formData = new FormData();
      formData.append('file', file);

      const config = {
        headers: {
            'Access-Control-Allow-Origin': 'http://images.aakashinfotech.com',  // CORS settings
            'Content-Type': 'application/x-www-form-urlencoded',   // Ensure content type is correct
            'authorizationToken': token
          },
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          const percentage = Math.floor((loaded * 100) / total);

          setUploadProgress((prevProgress) => ({
            ...prevProgress,
            [file.name]: percentage,
          }));
        },
      };
      const url = 'https://images.aakashinfotech.com/aak-logic/';

      return axios.post(url, formData, config)
        .then((response) => response)
        .catch((error) => {
          setUploadErrors((prevErrors) => [
            ...prevErrors,
            { name: file.name, error: error.message },
          ]);
          throw error;
        });
    });

    try {
        await Promise.all(uploaders);
        setSuccessAlert(true); // Show success alert
        setFiles([]); // Clear files
        setUploadProgress({}); // Clear upload progress
      } catch (error) {
        console.error('Some files failed to upload:', error);
      }
  };

  const handleRetry = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const config = {
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        const percentage = Math.floor((loaded * 100) / total);

        setUploadProgress((prevProgress) => ({
          ...prevProgress,
          [file.name]: percentage,
        }));
      },
    };

    try {
        const url = 'https://images.aakashinfotech.com/aak-logic/';

      await axios.post(url, formData, config,{
        headers: {
            'Access-Control-Allow-Origin': 'http://*.aakashinfotech',  // CORS settings
            'Content-Type': 'application/x-www-form-urlencoded',   // Ensure content type is correct
            'authorizationToken': token
          },
      });
      setUploadErrors((prevErrors) => prevErrors.filter((err) => err.name !== file.name));
    } catch (error) {
      console.error('Error retrying file upload:', error);
    }
  };

  return (
    <>
        <Box sx={{ m:5, textAlign: 'center' }}>
            <TextField
            id="filled-password-input"
            className='token'
            label="Token"
            type="password"
            autocomplete="off"
            required
            onChange={e => {
                setToken(e.target.value);
            }}
            />  
        </Box>  
        <Box sx={{ textAlign: 'center' }}>
    
            <label htmlFor="file-upload">
            <Input
            accept="*"
            id="file-upload"
            multiple
            type="file"
            onChange={handleFilesChange}
            />
            <Button variant="contained" component="span">
            Choose Files
            </Button>
        </label>
        <Button
            variant="contained"
            color="primary"
            onClick={handleUpload}
            sx={{ marginLeft: 2 }}
        >
            Upload
        </Button>
        {files.map((file) => (
            <Box key={file.name} sx={{ marginTop: 2 }}>
            <Typography variant="body2">{file.name}</Typography>
            <LinearProgress variant="determinate" value={uploadProgress[file.name] || 0} />
            <Typography variant="body2">{uploadProgress[file.name] || 0}%</Typography>
            </Box>
        ))}
        {successAlert && (
        <Alert severity="success" onClose={() => setSuccessAlert(false)} sx={{ marginTop: 2 }}>
          All files uploaded successfully!
        </Alert>
        )}
        {uploadErrors.length > 0 && (
            <Box sx={{ marginTop: 2 }}>
            <Typography variant="h6">Failed Uploads:</Typography>
            {uploadErrors.map((fileError) => (
                <Alert
                severity="error"
                action={
                    <Button color="inherit" size="small" onClick={() => handleRetry(files.find(file => file.name === fileError.name))}>
                    RETRY
                    </Button>
                }
                key={fileError.name}
                >
                {fileError.name}: {fileError.error}
                </Alert>
            ))}
            </Box>
        )}
        </Box>
    </>
  );
};

export default Upload;
